import { render, staticRenderFns } from "./BrowserTranslateToggle.vue?vue&type=template&id=0e96b146&scoped=true"
import script from "./BrowserTranslateToggle.vue?vue&type=script&lang=js"
export * from "./BrowserTranslateToggle.vue?vue&type=script&lang=js"
import style0 from "./BrowserTranslateToggle.vue?vue&type=style&index=0&id=0e96b146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96b146",
  null
  
)

export default component.exports